import YICUClassPage from "./YICUClassPage";

const CONTENT = {
  photos: [
    { src: "/images/YICU/2016/2016-YICU-Nominees.jpg", caption: "YICU 2016 Nominees — Top Row (L-R): Kaylin Richards, Camron Hinman, Peris Story, Alex Hopper, Alicia Ramos, Chloe Cope, Grace Gauley, Sankalp Amaravadi. Bottom Row (L-R): Priyamsa Mikkilineni, Dhruv Rebba, Aaron Martin, Oviya Sougoumarane, Fiona Ward Shaw, Ryan Sparks, Krista Barth, Shannon Doherty, Riley Davis. Not pictured: Antoinese Watson, Bronwen Boyd, Dana Lopez, Dominic Moore, Jacob Labertew, Jordan Cherry, Kate Lorenz, Raylissa Rusk, Whitney Irmeger" },
    { src: "/images/YICU/2016/2016-YICU-Winners.jpg", caption: "YICU 2016 Winners (L-R): Alex Hopper, Alicia Ramos, Camron Hinman, Dhruv Rebba, Kaylin Richards, Oviya Sougomarane. Not pictured: Antoinese Watson, Bronwen Boyd, Dominic Moore, Jordan Cherry" },
  ],
  winners: [
    { label: "2016 Winners", color: "pink", items: ["Alex Hopper", "Alicia Ramos", "Antoinese Watson", "Bronwen Boyd", "Camron Hinman", "Dhruv Rebba", "Dominic Moore", "Jordan Cherry", "Kaylin Richards", "Oviya Sougomarane"] },
  ],
};

export default function Yicu2016() {
  return <YICUClassPage year="2016" content={CONTENT} />;
}